//src/hooks/useListAllSharedByMe.ts
import useShareStore from 'src/store/api/useShareStore';
import { useSidebarStore } from 'src/store/layout/useSidebarStore';
 
const useRefreshListAllSharedByMe = () => {
  const { selectedItemId } = useSidebarStore((state) => ({
    selectedItemId: state.selectedItemId,
  }));
  const { refreshListAllShareByUser, isShareByLoading, ShareByError, ShareBySuccessMessage, sharedByUserItems, shareByCurrentPage, shareByTotalPages, totalSharedByItems,rowsPerPage } = useShareStore((state) => ({
    refreshListAllShareByUser: state.refreshListAllShareByUser,
    isShareByLoading: state.isShareByLoading,
    ShareByError: state.ShareByError,
    ShareBySuccessMessage: state.ShareBySuccessMessage,
    sharedByUserItems: state.sharedByUserItems,
    shareByCurrentPage: state.shareByCurrentPage,
    shareByTotalPages: state.shareByTotalPages,
    totalSharedByItems: state.totalSharedByItems,
    rowsPerPage: state.rowsPerPage,

  }));

  return { refreshListAllShareByUser, isShareByLoading, ShareByError, ShareBySuccessMessage, sharedByUserItems, shareByCurrentPage, shareByTotalPages, totalSharedByItems, ID: selectedItemId, rowsPerPage};
};

export default useRefreshListAllSharedByMe;
